<template>
  <b-container>
    <h4>Teacher Training Modules By District</h4>
    <b-row class="m-4">
      <b-col>
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-table
      v-cloak
      responsive
      :fields="fields"
      :items="moduleTable"
      :striped="true"
      :bordered="true"
      :hover="true"
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    ></b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="moduleTable.length || 0"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
      <b-col>
        <download-button :export="moduleTable" :file="file"></download-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import DownloadButton from '../components/DownloadButton';

export default {
  name: 'DataTeacher',
  components: {
    DownloadButton,
  },
  data() {
    return {
      file: 'teacher-training-modules-completion',
      fields: [
        { key: 'country', label: 'Country', sortable: true },
        { key: 'region', label: 'Region', sortable: true },
        { key: 'district', label: 'District', sortable: true },
        {
          key: 'avg_modules',
          label: 'Average Modules Completed',
          sortable: true,
        },
      ],
      currentPage: 0,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    };
  },
  methods: {
    ...mapActions({
      GET_MODULE_TABLE: 'dashboards/GET_TEACHER_MODULE_TABLE',
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
  },
  computed: {
    moduleTable() {
      return this.$store.state.dashboards.teacherModuleTable;
    },
  },
  mounted() {
    this.GET_MODULE_TABLE();
  },
};
</script>
